// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconSignature = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M17.274 9.688L18.586 11 20 9.586 12.414 2 11 3.414l1.312 1.312L5 8.382V17h8.618zm-1.49-1.49L12.381 15H8.414l3.793-3.793-1.414-1.414L7 13.586V9.618l6.803-3.401z"
    />,
    <path d="M5 21h14v-2H5z" />
  );
export default SvgIconSignature;
